import * as eHubApi from "./data.service";

function createSO(req) {
  return eHubApi.post("/api/so/create", req);
}

function getDefShipZone(req) {
  return eHubApi.get(
    `/api/so/get-def-ship-zone?customerCode=${req.customerCode}&postcode=${req.postcode}`
  );
}

function getOrderShelfLife(req) {
  return eHubApi.get(
    `/api/so/get-order-shelf-life?consigneeCode=${req.consigneeCode}&customerCode=${req.customerCode}`
  );
}

function getOrderType(req) {
  return eHubApi.get(`/api/so/get-order-type?customerCode=${req.customerCode}`);
}

export function getSOCustomerCarrier(req){
  return eHubApi.get(`/api/so/get-customer-carrier?customerCode=${req.customerCode}`)
}

function getSOList(req) {
  return eHubApi.get(`/api/so/list?customerCode=${req.customerCode}&status=${req.status}&orderDate=${req.orderDate}`);
}

function getSOStatusCount(req) {
  return eHubApi.get(`/api/so/get-status-count?customerCode=${req.customerCode}`);
}

function getSOLog(req) {
  return eHubApi.get(`/api/so/log?orderId=${req.orderId}&orderNumber=${req.orderNumber}&customerCode=${req.customerCode}&status=${req.status}`);
}

export function getSOStatusLog(req) {
  return eHubApi.get(`/api/so/log/status?orderId=${req.orderId}&orderNumber=${req.orderNumber}&customerCode=${req.customerCode}&status=${req.status}`);
}

function getSO(req) {
  return eHubApi.get(`/api/so/get?orderId=${req.orderId}`);
}

export function CreateSOBackOrder(req) {
  return eHubApi.post(`/api/so/create-back-order?orderNumber=${req.orderNumber}`);
}

function editSO(req) {
  return eHubApi.put(`/api/so/edit?orderId=${req.orderId}`, req.req);
}

export function editSOCarrier(req) {
  return eHubApi.post("/api/so/carrier/edit", req);
}

export function editSOOrderType(req) {
  return eHubApi.post("/api/so/order-type/edit", req);
}

function deleteSO(req) {
  return eHubApi.del(`/api/so/delete?orderId=${req.orderId}`);
}

function uploadSO(req) {
  return eHubApi.post("/api/so/upload", req);
}

function createDO(req) {
  return eHubApi.post("/api/do/create", req);
}

function getDOList(req) {
  return eHubApi.get(`/api/do/list?customerCode=${req.customerCode}&status=${req.status}&orderDate=${req.orderDate}`);
}

function getDOStatusCount(req) {
  return eHubApi.get(`/api/do/get-status-count?customerCode=${req.customerCode}`);
}

function getDO(req) {
  return eHubApi.get(`/api/do/get?delOrderId=${req.delOrderId}`);
}

function editDO(req) {
  return eHubApi.put(`/api/do/edit?delOrderId=${req.delOrderId}`, req.req);
}

function deleteDO(req) {
  return eHubApi.del(`/api/do/delete?delOrderId=${req.delOrderId}`);
}

export function cancelDO(req) {
  return eHubApi.del(`/api/do/cancel?delOrderId=${req.delOrderId}`);
}

function getDOLog(req) {
  return eHubApi.get(`/api/do/log?delOrderId=${req.delOrderId}`);
}

function editDOTSmallCarton(req) {
  return eHubApi.post(`/api/do/tsmallcarton/edit`, req);
}

function getPreallocate(req) {
  return eHubApi.post(`/api/task-assignment/preallocate?customerCode=${req.customerCode}`);
}

export function getTAFilterOptions(req) {
  return eHubApi.get(`/api/task-assignment/get-filter-options?customerCode=${req.customerCode}`);
}

export function getTAHasPriority(req) {
  return eHubApi.get(`/api/task-assignment/has-priority?customerCode=${req.customerCode}`);
}

function getTaskAssignmentList(req) {
  const category = encodeURIComponent(req.category)
  return eHubApi.get(
    `/api/task-assignment/list?customerCode=${req.customerCode}&status=${req.status}&shippingZone=${req.shippingZone}&category=${category}&orderType=${req.orderType}&sales=${req.sales}&sku=${req.sku}&qty=${req.qty}&priority=${req.priority}&engraving=${req.engraving}&orderDate=${req.orderDate}&orderTime=${req.orderTime}`
  );
}

function taskAllocate(req) {
  return eHubApi.post("/api/task-assignment/allocate", req);
}

function taskUnallocate(req) {
  return eHubApi.post("/api/task-assignment/unallocatev1_", req);
}

export function taskConfirm(req) {
  return eHubApi.post("/api/task-assignment/confirm", req);
}

function getTAQueueStatusCount(req) {
  return eHubApi.get(
    `/api/task-assignment/get-queue-status-count?customerCode=${req.customerCode}`
  );
}

function getTAExceptional(req) {
  return eHubApi.get(
    `/api/task-assignment/get-exceptional?customerCode=${req.customerCode}`
  );
}

function getTAInQueue(req) {
  return eHubApi.get(`/api/task-assignment/get-in-queue?customerCode=${req.customerCode}`);
}

export function resendTAInQueue(req) {
  return eHubApi.post("/api/task-assignment/queue/resend",req);
}

export function waveUnallocate(req) {
  return eHubApi.post(`/api/task-assignment/wave/unallocate?queueId=${req.queueId}`,{});
}

function getTAPickSlipLocation(req) {
  return eHubApi.get(`/api/task-assignment/get-pickslip-location?customerCode=${req.customerCode}`);
}
export const assignTAPickslipLocation = (req) => {
  return eHubApi.post("/api/task-assignment/assign-pickslip-location", req);
};
function getTAPickSlip(req) {
  return eHubApi.get(`/api/task-assignment/pickslip?customerCode=${req.customerCode}&type=${req.type}&basketId=${req.basketId}`);
}

function exportTAExceptional(req) {
  return eHubApi.post_file("/api/task-assignment/export-exceptional", req);
}

export function getAllocatedOptions(req) {
  return eHubApi.get(`/api/picking/get-allocated-options?customerCode=${req.customerCode}`);
}

function getPickslips(req) {
  return eHubApi.get(
    `/api/picking/get-pickslips?orderNumber=${req.orderNumber}&waveNumber=${req.waveNumber}`
  );
}

export function getPickslipLog(req) {
  return eHubApi.get(
    `/api/picking/log?pickslipId=${req.pickslipId}`
  );
}

export function getPickslipPickLog(req) {
  return eHubApi.get(
    `/api/pickslip/pick/log?pickslipNumber=${req.pickslipNumber}`
  );
}

export function getPickslipPackLog(req) {
  return eHubApi.get(
    `/api/pickslip/pack/log?pickslipNumber=${req.pickslipNumber}`
  );
}

function getPickslipsDetails(req) {
  return eHubApi.get(
    `/api/picking/get-pickslips-details?orderNumber=${req.orderNumber}&waveNumber=${req.waveNumber}&skuCode=${req.skuCode}`
  );
}

function getAvailableLocations(req) {
  return eHubApi.get(
    `/api/picking/get-available-locations?waveNumber=${req.waveNumber}&orderNumber=${req.orderNumber}&skuCode=${req.skuCode}`
  );
}

export function getAmendDetails(req) {
  return eHubApi.get(
    `/api/pickslip/amend/details?orderNumber=${req.orderNumber}&waveNumber=${req.waveNumber}&skuCode=${req.skuCode}`
  );
}

function updatePreview(req) {
  return eHubApi.post("/api/picking/update-preview", req);
}

export function updateAllocate(req) {
  return eHubApi.post("/api/picking/update-allocate", req);
}

function updateSave(req) {
  return eHubApi.post("/api/picking/update-save", req);
}

function getFilterOptions(req) {
  return eHubApi.get(`/api/load-manifest/get-filter-options?customerCode=${req.customerCode}`);
}

function getDOData(req) {
  return eHubApi.get(
    `/api/load-manifest/get-do-data?customerCode=${req.customerCode}&custOrdNbr=${req.custOrdNbr}&shippingZone=${req.shippingZone}&doNumber=${req.doNumber}`
  );
  //return eHubApi.post("/api/load-manifest/get-do-data", req);
}

export function createLoadManifest(req) {
  return eHubApi.post("/api/load-manifest/create", req);
}

export function getManifestList(req) {
  return eHubApi.get(
    `/api/load-manifest/list?customerCode=${req.customerCode}&status=${req.status}`
  );
}

export function getManifestStatusCount(req) {
  return eHubApi.get(`/api/load-manifest/get-status-count?customerCode=${req.customerCode}`);
}

export function getManifestLog(req) {
  return eHubApi.get(
    `/api/load-manifest/log?manifestNumber=${req.manifestNumber}&customerCode=${req.customerCode}`
  );
}

export function editManifestCarrier(req) {
  return eHubApi.post("/api/load-manifest/carrier/edit", req);
}

export function editManifestTSmallCarton(req) {
  return eHubApi.post("/api/load-manifest/tsmallcarton/edit", req);
}

export function getReturnOrderWebApiList(req) {
  return eHubApi.get(`/api/return/list?customerCode=${req.customerCode}`);
}

export function getReturnOrderWebApiLog(req) {
  return eHubApi.get(
    `/api/return/log?customerCode=${req.customerCode}&returnNumber=${encodeURIComponent(
      req.returnNumber ?? ""
    )}&custOrdNbr=${encodeURIComponent(req.custOrdNbr ?? "")}`
  );
}

export function getFulfillmentOrders(req) {
  return eHubApi.get(`/api/fulfillment/list?customerCode=${req.customerCode}`);
}

export function initFulfillmentAwb(req) {
  return eHubApi.post("/api/fulfillment/init-awb", req);
}

export function getLoadManifest(req) {
  //console.log(manifestNumber)
  return eHubApi.get(`/api/load-manifest/get?manifestNumber=${req.manifestNumber}`);
}

export function editLoadManifest(req) {
  return eHubApi.put(
    `/api/load-manifest/edit?manifestNumber=${req.manifestNumber}&customerCode=${req.customerCode}`,
    req.req
  );
}

export function deleteLoadManifest(req) {
  return eHubApi.del(`/api/load-manifest/delete?customerCode=${req.customerCode}&manifestNumber=${req.manifestNumber}`);
}

function getProofOfDelivery(req) {
  return eHubApi.get(`/api/ProofOfDelivery/list?customerCode=${req.customerCode}`);
}

function updateManifest(req) {
  console.log(req);
  return eHubApi.post("/api/ProofOfDelivery/create", req);
}

function getTaskList(req) {
  return eHubApi.get(`/api/task-list/list?customerCode=${req.customerCode}&status=${req.status}`);
}

export function getTaskListStatusCount(req) {
  return eHubApi.get(`/api/task-list/get-status-count?customerCode=${req.customerCode}`);
}

function updateTaskList(req) {
  return eHubApi.post("/api/task-list/update", req);
}

export const getESOList = (req) => {
  return eHubApi.get(`/api/eso/list?customerCode=${req.customerCode}&status=${req.status}`);
};

export const getESOStatusCount = (req) => {
  return eHubApi.get(`/api/eso/get-status-count?customerCode=${req.customerCode}`);
};

export const convertSO = (req) => {
  return eHubApi.post("/api/eso/convert-so", req);
};

export const editESO = (req) => {
  return eHubApi.post("/api/eso/edit", req);
};

export const getSalesOptions = (req) => {
  return eHubApi.get(`/api/so/get-sales?customerCode=${req.customerCode}`);
};

function uploadOB(req) {
  return eHubApi.post("/api/openingbalance/upload", req);
}

function getESOLog(req) {
  return eHubApi.get(`/api/eso/log?custOrdNbr=${req.custOrdNbr}&customerCode=${req.customerCode}&status=${req.status}`);
}

function getRecvReturn(req) {
  return eHubApi.get(`/api/recvreturn/get-recv-return?customerCode=${req.customerCode}`);
}

function getROLog(req) {
  return eHubApi.get(`/api/recvreturn/rolog?orderNumber=${req.orderNumber}&customerCode=${req.customerCode}&status=${req.status}`);
}

function getReturnOrderScan(req) {
  return eHubApi.get(`/api/recvreturn/get-recv-order-scan?orderNumber=${req.orderNumber}`);
}

export const getPickConfirmList = (req) => eHubApi.get(`/api/snt/pick/list?customerCode=${req.customerCode}`)

export const resendPickConfirm = (req) => eHubApi.post("/api/snt/pick/resend",req)

export const getPutawayReturnList = (req) => eHubApi.get(`/api/snt/return/list?customerCode=${req.customerCode}`)

export const resendPutawayReturn = (req) => eHubApi.post("/api/snt/return/resend",req)

export const getSntStatus = (req) => eHubApi.get(`/api/snt/status?customerCode=${req.customerCode}`)

export const getManifestEtraxList = (req) => eHubApi.get(`/api/snt/manifest-etrax/list?customerCode=${req.customerCode}`)

export const resendManifestEtrax= (req) => eHubApi.post("/api/snt/manifest-etrax/resend",req)

export function getPickslipAmendOptions(req) {
  return eHubApi.get(`/api/pickslip-amend/options?customerCode=${req.customerCode}`);
}

export function getPickslipAmendPickslip(req) {
  return eHubApi.get(`/api/pickslip-amend/pickslip?pickslipId=${req.pickslipId}`);
}

export function getPickslipAmendDetails(req) {
  return eHubApi.get(`/api/pickslip-amend/details?pickslipId=${req.pickslipId}&skuCode=${req.skuCode}`);
}

export function previewPickslipAmendDetails(req) {
  return eHubApi.post("/api/pickslip-amend/preview", req);
}

export function savePickslipAmendDetails(req) {
  return eHubApi.post("/api/pickslip-amend/save", req);
}

export {
  createSO,
  getDefShipZone,
  getOrderShelfLife,
  getSOList,
  getSOStatusCount,
  getSOLog,
  getSO,
  editSO,
  deleteSO,
  getOrderType,
  uploadSO,
  createDO,
  getDOList,
  getDOStatusCount,
  getDO,
  editDO,
  deleteDO,
  getDOLog,
  editDOTSmallCarton,
  getPreallocate,
  taskUnallocate,
  getTaskAssignmentList,
  taskAllocate,
  getTAQueueStatusCount,
  getTAExceptional,
  getTAInQueue,
  exportTAExceptional,
  getTAPickSlipLocation,
  getTAPickSlip,
  getFilterOptions,
  getDOData, 
  getProofOfDelivery,
  updateManifest,
  getTaskList,
  updateTaskList,
  getPickslips,
  getPickslipsDetails,
  getAvailableLocations,
  updatePreview,
  updateSave,
  uploadOB,
  getESOLog,
  getRecvReturn,
  getROLog,
  getReturnOrderScan
};
